import { useState } from 'react';
import { IoSearch } from 'react-icons/io5';
import useDebounce from '../../../hook/useDebounce';
import { useNavigate } from 'react-router-dom';
import Toast from '../../../utils/toastManager';
import useScreenWidth from '../../../hook/useScreenWidth';
import { buildRoutes } from '@/service/buildRoutes';

const Search = ({ placeholder = 'Search TRC', basePath }) => {
	const [searchKey, setSearchKey] = useState('');
	const navigate = useNavigate();
	const [isOpen, setIsOpen] = useState(false);
	const { width } = useScreenWidth();
	const isAllowedToOpen = width < 1200;

	const handleOpen = () => {
		setIsOpen(prev => !prev);
	};
	const handleClose = () => {
		setIsOpen(false);
	};

	const validateSearch = query => {
		if (query.trim().length < 3) {
			Toast.error('Please enter at least 3 characters');
			return false;
		}
		const regex = /^[a-zA-Z0-9\s]+$/;
		if (!regex.test(query)) {
			Toast.error('Please enter a valid search term', { position: 'bottom-center' });
			return false;
		}
		return true;
	};

	const handleSearch = () => {
		const query = searchKey.trim();
		if (validateSearch(query)) {
			navigate(buildRoutes.toTRCSearch(query, basePath));
		}
		handleClose();
		setSearchKey('');
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter') {
			handleSearch();
		}
	};

	return (
		<>
			<div className="d-none d-xl-flex input-group me-1 me-xl-3 w-25 justify-content-end">
				<input
					type="text"
					className="form-control bg-secondary border-0 text-white"
					placeholder={placeholder}
					value={searchKey}
					onChange={e => setSearchKey(e.target.value)}
					onKeyDown={handleKeyDown}
				/>
				<button onClick={handleSearch} className="btn border-0" type="button"
					style={{
						backgroundColor: '#82868B',
						color: searchKey ? '#3cb4e4' : 'white',
					}}>
					<IoSearch size={20} />
				</button>
			</div>

			<div
				className="d-flex align-items-center gap-1 d-xl-none me-1"
				style={{
					padding: '0.25rem',
					border: '1px solid #3CB4E4',
					borderRadius: '0.5rem'
				}}
				onClick={handleOpen}
			>
				<IoSearch size={16} color="#3CB4E4" />
				<span className="sr-only">Search</span>
			</div>

			{/* Overlay */}
			{isAllowedToOpen && isOpen && (
				<div
					onClick={handleClose}
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						background: 'rgba(0,0,0,0.6)',
						zIndex: 999
					}}
				/>
			)}

			<div
				style={{
					display: isAllowedToOpen && isOpen ? 'block' : 'none',
					position: 'absolute',
					top: '100%',
					left: 0,
					right: 0,
					zIndex: 1000,
					width: '80%',
					borderRadius: '0.5rem',
					margin: '0 auto',
					border: '1px solid #3CB4E4'
				}}
			>
				<div className="d-flex input-group w-100">
					<input
						type="text"
						className="form-control bg-secondary border-0 text-white"
						placeholder={placeholder}
						value={searchKey}
						onChange={e => setSearchKey(e.target.value)}
					/>
					<button onClick={handleSearch} className="btn border-0" type="button" 
					style={{
						backgroundColor: '#82868B',
						color: searchKey ? '#3cb4e4' : 'white',
					}}>
						<IoSearch size={20} />
					</button>
				</div>
			</div>
		</>
	);
};

export default Search;
